import { App } from '@capacitor/app'
import { Capacitor } from '@capacitor/core'
import { useRouter } from 'vue-router'
import { parseDeepLinkPath } from '@/utils/deepLink'

export function useDeepLinking() {
  const router = useRouter()

  const navigateToUrl = async (url) => {
    const path = parseDeepLinkPath(url)
    if (!path) return

    try {
      const resolved = router.resolve(path)
      if (resolved.name === 'NotFound' && path !== '/') {
        console.warn('Deep link path not found:', path)
        return
      }
      await router.push(path)
    } catch (error) {
      console.error('Deep link navigation failed:', error)
    }
  }

  const navigateFromNotification = (notification) => {
    const data = notification?.notification?.data || notification?.data || {}
    const url = data.url || data.deep_link || data.link
    const route = data.route || data.path

    if (url) {
      navigateToUrl(url)
    } else if (route) {
      navigateToUrl(route.startsWith('/') ? route : `/${route}`)
    }
  }

  const initDeepLinking = async () => {
    if (!Capacitor.isNativePlatform()) return

    const launch = await App.getLaunchUrl()
    if (launch?.url) {
      await navigateToUrl(launch.url)
    }

    App.addListener('appUrlOpen', async (event) => {
      console.log('Deep Link event:', event)
      if (event?.url) {
        await navigateToUrl(event.url)
      }
    })
  }

  return {
    initDeepLinking,
    navigateToUrl,
    navigateFromNotification
  }
}
